module.exports = __webpack_public_path__ + "static/media/Icon_ChevronUp.1e26022d.svg";